import React, { Component } from 'react'
import styles from './EmailForm.css';
import fire from '../../fire';

export default class EmailForm extends Component {
    constructor(props) { 
        super(props);
        this.state = {name: '', email: '', subject: '', textArea: ''};
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleInputChange(event) {
      const target = event.target;
      const name = target.name;
      this.setState({ [name]: target.value }) // chooses the correct input
    }

    handleSubmit(event){
      event.preventDefault();
      fire.database().ref('messages').push(
        `NAME: ${this.state.name}
        EMAIL: ${this.state.email}
        SUBJECT: ${this.state.subject}
        TEXT: ${this.state.textArea}` 
      , error => { error ? alert(`There was an error: ${error}`) : alert(`Your mail has been sent`) })
      this.setState({name: '', email: '', subject: '', textArea: ''}); 
      document.getElementById('emailForm').reset();

    }

  render() {
    return (
      <div className={styles.emailForm}>
      <h2>Email Form</h2>
      <form id='emailForm' onSubmit={this.handleSubmit.bind(this)}>
        <label>
            Name
            <input
            name='name' type='text' required 
            autoComplete='on' placeholder='Enter your name' 
            onChange={this.handleInputChange}/>
            </label>
            <label> 
            Email
            <input
            name='email' type='email' required autoComplete='on' 
            placeholder='Enter your email' 
            onChange={this.handleInputChange}/>
            </label>
           <label>
             Topic
             <input
              name='subject' type='text' required 
              autoComplete='on' placeholder='Type the topic' 
              onChange={this.handleInputChange}/>
           </label>
           <label>
             Subject
             <textarea name='textArea'  onChange={this.handleInputChange}/>
           </label>
           <input type='submit' value='Submit'/>
      </form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/EmailForm/EmailForm.js